




















































































import { Vue, Component } from 'vue-property-decorator';
import {
  Progress,
  RadioGroup,
  Radio,
  Button,
  Checkbox,
  CheckboxGroup,
} from 'vant';
import { getBaseInfo, getList, vote } from './api';
import qs from 'qs';
import VoteButton from './VoteButton.vue';

Vue.use(Progress)
  .use(RadioGroup)
  .use(Radio)
  .use(Button)
  .use(Checkbox)
  .use(CheckboxGroup);

@Component({
  components: {
    VoteButton,
  },
})
export default class Home extends Vue {
  newsInfo: any = {};
  questionArr: any[] = [];
  get newId() {
    return qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    }).id;
  }
  get voteParams() {
    return {
      newsId: this.newId,
      content: this.questionArr,
    };
  }
  async created() {
    await this.init();
    // 分享
    setTimeout(() => {
      this.$appShareInfo({
        title: this.newsInfo.title,
        url: window.location.href,
        subtitle: '您来投票吧！',
        classId: -1,
        id: -1,
        image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
    }, 500);
    this.$wxShareInfo({
      title: this.newsInfo.title,
      subtitle: '您来投票吧！',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  async init() {
    const infoRes: any = await getBaseInfo(this.newId);
    this.newsInfo = infoRes.data;
    const questionRes = await getList(this.newId);
    this.questionArr = questionRes.data;
    if (this.newsInfo.if_one === '1') {
      this.questionArr = this.questionArr.map((item: any, index: number) => {
        return { ...item, answer: [] };
      });
    }
  }
  votSuccess(res: any) {
    if (res.msg === '今天的票数已投票完毕，请明天再试!') {
      return;
    } else {
      setTimeout(() => {
        this.$router.go(0);
      }, 300);
    }
    console.log('success vote');
  }

  calcPercent(arr: any[], index: number) {
    const temp = arr.map((item: any) => Number(item.votes));
    const total = temp.reduce((pre, cur) => (pre += cur), 0);
    if (temp[index] === 0 || total === 0) {
      return 0;
    }
    return (temp[index] / total) * 100;
  }
}
